import { ContextInstanceVariableType } from "@/src/shared/schemas";
import { useContextStore } from "@/src/stores/useContextStore";
import { parseContextVariableValue } from "@/src/shared/utils/dataTypeHelpers";
import { isString } from "lodash";

export const getContextVariablesToUpdate = (
  formData: Record<string, ContextInstanceVariableType["value"]>,
  dirtyFields: Partial<
    Readonly<{
      [x: string]: any;
    }>
  >,
  allowNulls = false,
) => {
  const contextVariablesToUpdate = Object.keys(dirtyFields || {}).reduce(
    (acc, key) => {
      const dirtyFieldValue = dirtyFields[key];
      const contextVariableToUpdate = useContextStore
        .getState()
        .getVariable(key);

      if (dirtyFieldValue && contextVariableToUpdate) {
        const newValue = parseContextVariableValue(formData[key], {
          dataType: contextVariableToUpdate.dataType,
          key,
        });
        if (isString(newValue) || (allowNulls && newValue === null)) {
          acc.push({ ...contextVariableToUpdate, value: newValue });
        }
      }

      return acc;
    },
    [] as ContextInstanceVariableType[],
  );

  return contextVariablesToUpdate;
};
